import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SessionProp from '../propTypes/sessionProp';
import translate from '../../../commonComponents/translate';
import { checkIfHasCreatorAccess, PURCHASE_STATUS } from '../propTypes/sessionUtils';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import WebinarContent from '../webinar/WebinarContent';

const WebinarSection = props => {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;
  /** Props */
  const { t, session, handleEnrollModal, handleQRModal } = props;
  const {
    purchaseStatus,
  } = session || {};
  // Already Paid or is free or has creator access
  const hasAccessToContent =
    purchaseStatus === PURCHASE_STATUS.FREE ||
    purchaseStatus === PURCHASE_STATUS.PAID ||
    checkIfHasCreatorAccess(session, loggedUserId);
  return (
    <div>
      {hasAccessToContent ? (
        <WebinarContent session={session} onQRModal={handleQRModal} />
      ) : (
        <span className="col-lg-12 locationBlock">
          <div className="m-portlet m-portlet--rounded
          m-portlet--rounded-force m-portlet--full-height
          location-container"
          />
            <div className="center-btn-middle">
              <div className="button">
                <div className="session-actions">
                  <button
                    type="button"
                    onClick={handleEnrollModal}
                    className="btn btn-md m-btn--pill btn-dynamic navigation-button"
                  >
                    {t('sessions_enrollSession')}
                  </button>
                </div>
              </div>
            </div>
        </span>
      )}
    </div>
  );
};

WebinarSection.propTypes = {
  t: PropTypes.func.isRequired,
  handleQRModal: PropTypes.func.isRequired,
  handleEnrollModal: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};

export default translate(WebinarSection);
